import { render, staticRenderFns } from "./TifTurnoInfoTurno.vue?vue&type=template&id=bd052fbc"
import script from "./TifTurnoInfoTurno.vue?vue&type=script&lang=js"
export * from "./TifTurnoInfoTurno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports